import { render } from "./VolunteersDetails.vue?vue&type=template&id=4ad4722a&scoped=true"
import script from "./VolunteersDetails.vue?vue&type=script&lang=js"
export * from "./VolunteersDetails.vue?vue&type=script&lang=js"

import "./VolunteersDetails.vue?vue&type=style&index=0&id=4ad4722a&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad4722a"]])

export default __exports__